<main class="not-found" aria-labelledby="not-found-title">
  <mat-card class="not-found__card" appearance="outlined">
    <mat-card-content>
    <img class="not-found__graphic" src="assets/404_img.png" alt="" aria-hidden="true">

    <h1 id="not-found-title">Page not found</h1>
    <p class="not-found__message">
      The page you're looking for may have been moved,<br class="not-found__desktop-break">
      deleted, or the link may be incorrect.
    </p>

    <div class="not-found__actions">
      <a mat-flat-button color="primary" routerLink="/app/home">
        <mat-icon>home</mat-icon>
        Go to Home
      </a>
      <button mat-stroked-button color="primary" type="button" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        Go Back
      </button>
    </div>

    </mat-card-content>
  </mat-card>
</main>
